import HOST from './host';

const USER = `${HOST}/user`;
const AUTH = `${HOST}/auth/login`;
const PARTICIPANT = `${HOST}/participant`;
const SITUATION_TABLE = `${HOST}/situation-table`;
const RECORD = `${HOST}/record`;

const API = {
    USER,
    AUTH,
    PARTICIPANT,
    SITUATION_TABLE,
    RECORD
};

export default API;
